import { Injectable } from "@angular/core";

/**
 * キャッシュされたURL
 * （主にAuthGuardとログイン部分で使用）
 */
@Injectable({ providedIn: 'root'})
export class CachedUrl {

  url: string = null;
}